import { render } from "./ExamMonitor.vue?vue&type=template&id=42bcec41&scoped=true"
import script from "./ExamMonitor.vue?vue&type=script&lang=js"
export * from "./ExamMonitor.vue?vue&type=script&lang=js"

import "./ExamMonitor.vue?vue&type=style&index=0&id=42bcec41&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bcec41"]])

export default __exports__